import { Breadcrumbs, Button, Chip } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { useContext, useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { emphasize, styled } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MyContext } from "../../App";
import { deleteData, fetchDataFromApi } from "../../utils/api";
import { FaPencilAlt } from "react-icons/fa";

// ================= Breadcrumb Style =================
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];

  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

// ================= Component =================
const Category = () => {
  const [catData, setCatData] = useState([]);

  // 🔥 delete dialog states
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const context = useContext(MyContext);

  // ================= Fetch Categories =================
  useEffect(() => {
    window.scrollTo(0, 0);

    context.setProgress(20);

    fetchDataFromApi("/api/category").then((res) => {
      setCatData(res);
      context.setProgress(100);
    });
  }, []);

  // ================= Open Delete Dialog =================
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpenDelete(true);
  };

  // ================= Confirm Delete =================
  const confirmDelete = () => {
    context.setProgress(40);

    deleteData(`/api/category/${selectedId}`)
      .then(() => {
        context.setProgress(100);

        context.setAlertBox({
          open: true,
          error: true,
          msg: "Category Deleted!",
        });

        fetchDataFromApi("/api/category").then((res) => {
          setCatData(res);
        });

        setOpenDelete(false);
      })
      .catch((err) => {
        console.error("Error deleting category:", err);
      });
  };

  return (
    <>
      <div className="right-content w-100">
        {/* ================= Header ================= */}
        <div className="card shadow border-0 w-100 flex-row p-4">
          <h5 className="mb-0">Category List</h5>

          <div className="ml-auto d-flex align-items-center">
            <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Dashboard"
                icon={<HomeIcon fontSize="small" />}
              />

              <StyledBreadcrumb
                label="Category"
                deleteIcon={<ExpandMoreIcon />}
              />
            </Breadcrumbs>

            <Link to="/category/add">
              <Button className="btn-blue ml-3 pl-3 pr-3">
                Add Category
              </Button>
            </Link>
          </div>
        </div>

        {/* ================= Table ================= */}
        <div className="card shadow border-0 p-3 mt-4">
          <div className="table-responsive mt-3">
            <table className="table table-bordered v-align">
              <thead className="thead-dark">
                <tr>
                  <th>IMAGE</th>
                  <th>CATEGORY</th>
                  <th>ACTION</th>
                </tr>
              </thead>

              <tbody>
                {catData?.categoryList?.length !== 0 &&
                  catData?.categoryList?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <img
                          src={`${context.baseUrl}/uploads/${item.images?.[0]}`}
                          className="w-100"
                          alt="Category"
                          style={{ maxWidth: "80px" }}
                        />
                      </td>

                      <td>{item.name}</td>

                      <td>
                        <div className="actions d-flex align-items-center">
                          {/* Edit */}
                          <Link to={`/category/edit/${item._id}`}>
                            <Button className="success" color="success">
                              <FaPencilAlt />
                            </Button>
                          </Link>

                          {/* Delete */}
                          <Button
                            className="error"
                            color="error"
                            onClick={() => handleDeleteClick(item._id)}
                          >
                            <MdDelete />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ================= Delete Confirmation Dialog ================= */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>Delete Category</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this category?
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>Cancel</Button>

          <Button
            color="error"
            variant="contained"
            startIcon={<MdDelete />}
            onClick={confirmDelete}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Category;
